import type { BffApiClient } from "@/app/api-client"
import type { InferRequestType } from "hono"

export type QueryInput = InferRequestType<
  BffApiClient["api"]["brands"]["$get"]
>["query"]

export function getBrandsQueryParams(
  apiClient: BffApiClient,
  queryInput: QueryInput,
) {
  return {
    queryKey: ["brands", queryInput],
    queryFn: async () => {
      const response = await apiClient.api.brands.$get({
        query: { blockchain: queryInput.blockchain },
      })

      if (!response.ok) throw await response.json()

      return response.json()
    },
  }
}
